import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The pepper hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a vivid hot-pink + coral palette for a bold,
 * cheerful adventurer. Choosing her recolours the WHOLE kid shell: the brand ramp drives buttons / meters /
 * rings in magenta-pink, the canvas blooms warm to a pink+coral dawn, and the hero stage takes her festive
 * dusk sky. Deliberately more saturated/punchy than royal's soft dusty-rose storybook palette — this is
 * energetic-adventure pink, not romantic-princess pink. Every brand colour is paired with its own foreground
 * for legibility.
 */
export const pepperTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — vivid magenta-pink. `soft`→`primary` is the button/meter gradient (white text); `deep` is
  // on-light text; `tint` is the softest fill; `glow-rgb` = #E11C67 for coloured shadows.
  '--color-primary': '#E11C67',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#EE6398',
  '--color-primary-deep': '#9E1F52',
  '--color-primary-tint': '#FCE1EC',
  '--color-primary-glow-rgb': '225 28 103',
  '--color-secondary': '#FDE3ED',
  '--color-secondary-fg': '#6E1B3E',
  '--color-accent': '#FF8C5A',
  '--color-accent-fg': '#4A1F00',
  // CANVAS — a soft pink bloom top-left, a sunny coral bloom bottom-right (a festive dawn behind the content).
  '--canvas-a': '#FCE1EC',
  '--canvas-b': '#FFEEE0',
  // A vivid magenta-plum festive dusk (white text stays AA over it).
  '--sky-top': '#3a1440',
  '--sky-mid': '#8a2d6b',
  '--sky-low': '#f0a8c9',
  '--sky-glow': '#ffcf9e',
  '--sky-fg': '#ffffff',
});
